import actions from "./actions";

const initState = {
    settingReadAllState: false,
    settingUpdateAllState: false,
    settingUpdateAllResult: {},
    settingUpdateApiState: null,
    refreshApiTokenState: null,
    settings: {
    //
    },
    salesTaxOn: undefined,
    serviceTaxOn: undefined,
    serviceTaxAccrualBasisOn: false,
    showExemptedTax: undefined,
    formTemplate: undefined,
    formColor: undefined,
    /* Shoebox */
    shoeboxContacts: [],
    shoeboxContactsPagination: {},
    shoeboxContact: undefined,
    readAllShoeboxContactsState: undefined,
    updateShoeboxEmailState: undefined,
    updateShoeboxNumberState: undefined,
    /* Number Format */
    readNumbersState: null,
    updateNumbersState: null,
    transactionNumbers: null,
    customTransactionNumberOn: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.SETTING_READ_ALL_REQUEST:
            return {
                ...state,
                settingReadAllState: 'request',
            };
        case actions.SETTING_READ_ALL_SUCCESS:
            return {
                ...state,
                settingReadAllState: 'success',
                settings: action.settings,
                salesTaxOn: action.settings.mysst_sales_tax_on,
                serviceTaxOn: action.settings.mysst_service_tax_on,
                showExemptedTax: action.settings.mysst_exempted_tax_code_show,
                formTemplate: action.settings.form_template,
                formColor: action.settings.form_color,
            };
        case actions.SETTING_UPDATE_MULTIPLE_REQUEST:
            return {
                ...state,
                settingUpdateAllState: 'request',
            };
        case actions.SETTING_UPDATE_MULTIPLE_SUCCESS:
            return {
                ...state,
                settingUpdateAllState: 'success',
                settingUpdateAllResult: action.settings,
            };
        case actions.SETTING_UPDATE_API_REQUEST:
            return {
                ...state,
                settingUpdateApiState: 'request',
            };
        case actions.SETTING_UPDATE_API_SUCCESS:
            return {
                ...state,
                settingUpdateApiState: 'success',
            };
        case actions.REFRESH_API_TOKEN_REQUEST:
            return {
                ...state,
                refreshApiTokenState: 'request',
            };
        case actions.REFRESH_API_TOKEN_SUCCESS:
            return {
                ...state,
                refreshApiTokenState: 'success',
            };
        case actions.SETTING_CHANGE_ALL:
            return {
                ...state,
                settings: action.request,
                salesTaxOn: action.request.mysst_sales_tax_on,
                serviceTaxOn: action.request.mysst_service_tax_on,
                showExemptedTax: action.request.mysst_exempted_tax_code_show,
                formTemplate: action.request.form_template,
                formColor: action.request.form_color,
            };
        case actions.SETTING_CHANGE_SALES_TAX_ON:
            return {
                ...state,
                salesTaxOn: action.salesTaxOn,
            };
        case actions.SETTING_CHANGE_SERVICE_TAX_ON:
            return {
                ...state,
                serviceTaxOn: action.serviceTaxOn,
            };
        case actions.SETTING_CHANGE_SERVICE_TAX_ACCRUAL_BASIS_ON:
            return {
                ...state,
                serviceTaxAccrualBasisOn: action.serviceTaxAccrualBasisOn,
            };
        case actions.SETTING_CHANGE_SHOW_EXEMPTED_TAX_CODES:
            return {
                ...state,
                showExemptedTax: action.showExemptedTax,
            };
        case actions.SETTING_CHANGE_FORM_TEMPLATE:
            return {
                ...state,
                formTemplate: action.formTemplate,
            };
        case actions.SETTING_CHANGE_FORM_COLOR:
            return {
                ...state,
                formColor: action.formColor,
            };

            /* Shoebox */
        case actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_REQUEST:
            return {
                ...state,
                readAllShoeboxContactsState: 'request',
            };
        case actions.SETTING_READ_ALL_SHOEBOX_CONTACTS_SUCCESS:
            return {
                ...state,
                readAllShoeboxContactsState: 'success',
                shoeboxContacts: action.contacts,
                shoeboxContactsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.SETTING_UPDATE_SHOEBOX_EMAIL_REQUEST:
            return {
                ...state,
                updateShoeboxEmailState: 'request',
            };
        case actions.SETTING_UPDATE_SHOEBOX_EMAIL_SUCCESS:
            return {
                ...state,
                updateShoeboxEmailState: 'success',
            };
        case actions.SETTING_UPDATE_SHOEBOX_NUMBER_REQUEST:
            return {
                ...state,
                updateShoeboxNumberState: 'request',
            };
        case actions.SETTING_UPDATE_SHOEBOX_NUMBER_SUCCESS:
            return {
                ...state,
                updateShoeboxNumberState: 'success',
            };
        case actions.SETTING_SET_SHOEBOX_CONTACT:
            return {
                ...state,
                shoeboxContact: action.contact,
            };
        case actions.SETTING_NUMBER_READ_ALL_REQUEST:
            return {
                ...state,
                readNumbersState: 'request',
            };
        case actions.SETTING_NUMBER_READ_ALL_SUCCESS:
            return {
                ...state,
                readNumbersState: 'success',
                transactionNumbers: action.transactionNumbers,
                customTransactionNumberOn: action.customTransactionNumberOn,
            };
        case actions.SETTING_NUMBER_UPDATE_ALL_REQUEST:
            return {
                ...state,
                updateNumbersState: 'request',
            };
        case actions.SETTING_NUMBER_UPDATE_ALL_SUCCESS:
            return {
                ...state,
                updateNumbersState: 'success',
            };

        default:
            return state;
    }
}
